import React, { useEffect, useState } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { Book, BookContext, BookCover } from '@astrid/components'
import { HttpErrors } from '@astrid/shared'
import BookFactory from 'Book/BookFactory/BookFactory'
import { ScreenNames } from 'analytics/analytics'
import { ROUTES } from 'routes/routes'

import { useTrackScreenShown } from 'hooks/useTrackScreenShown'

import './BookView.scss'
import { getBook } from './api'

interface IState {
  currentBook: Book | null
  loading: boolean
  coverOpen: boolean
}

const BookView = (props: RouteComponentProps<{ id: string; bookContext: BookContext }>) => {
  useTrackScreenShown(ScreenNames.Book)

  const bookId = props.match.params.id
  const bookContext = props.match.params.bookContext
  const [state, setState] = useState<IState>({
    loading: true,
    currentBook: null,
    coverOpen: true
  })

  if (!bookId) props.history.replace(ROUTES.INSIGHTS)

  useEffect(() => {
    // GA_pageview('/book')
    ;(async () => {
      try {
        const { data: currentBook } = await getBook(bookId)
        setState((state) => ({
          ...state,
          loading: false,
          currentBook: currentBook
        }))
      } catch (err) {
        if (typeof err === 'string' && err === HttpErrors.BookNotFound) {
          props.history.replace(ROUTES.INSIGHTS)
        }
      }
    })()
    //eslint-disable-next-line
  }, [])

  const onCompleteBook = () => {
    props.history.push(ROUTES.LIBRARY)
  }

  if (state.loading) {
    return null
  }

  if (state.coverOpen) {
    return (
      <div className="book-cover-wrapper">
        <BookCover
          disableContinue={false}
          book={state.currentBook!}
          bookContext={bookContext}
          onStart={() => setState((state) => ({ ...state, coverOpen: false }))}
        />
      </div>
    )
  } else if (state.currentBook) {
    return <BookFactory book={state.currentBook} onCompleteBook={onCompleteBook} bookContext={bookContext} />
  } else return null
}

export default withRouter(BookView)
